export default __webpack_public_path__ + "static/media/upperBackground.0a1c93f3.png";